import {
  getDefaultProductSelection,
  getDisplayProductDescription,
  normalizeLandstarProductImageUrl
} from "../utils/helpers.js";

function ProductCard({
  product,
  eligibilityBadge = "",
  selected,
  selectionLimit = Infinity,
  hasReachedSelectionLimit = false,
  selection,
  onSelectionChange,
  onSelect,
  personalizationEnabled = false,
  lockedSelected = false
}) {
  const normalizedSelection = getDefaultProductSelection(product, selection);
  const imageUrl = normalizeLandstarProductImageUrl(product.image);
  const description = getDisplayProductDescription(product.description);
  const badgeText = eligibilityBadge || product.badge || "";
  const buttonClassName = lockedSelected
    ? "landstar-secondary-button"
    : selected
    ? "landstar-danger-button"
    : !hasReachedSelectionLimit
      ? "landstar-primary-button"
      : "landstar-secondary-button landstar-product-choice-button-muted";
  const buttonLabel = lockedSelected
    ? "Included in Kit"
    : selected
    ? selectionLimit === 1
      ? "Selected"
      : "Remove Reward"
    : selectionLimit === 1
      ? "Choose Reward"
      : "Add Reward";

  return (
    <article className={`landstar-product-card${selected ? " is-selected" : ""}`}>
      {badgeText ? <div className="landstar-product-badge">{badgeText}</div> : null}
      <img src={imageUrl} alt={product.name} className="landstar-product-image" />
      <h3>{product.name}</h3>
      <p>{description}</p>

      <label className="landstar-field-label" htmlFor={`size-${product.id}`}>
        Size
      </label>
      <select
        id={`size-${product.id}`}
        value={normalizedSelection.size}
        onChange={(event) => onSelectionChange(product.id, "size", event.target.value)}
      >
        <option value="">Select a size</option>
        {product.sizes.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>

      <label className="landstar-field-label" htmlFor={`color-${product.id}`}>
        Color
      </label>
      <select
        id={`color-${product.id}`}
        value={normalizedSelection.color}
        onChange={(event) => onSelectionChange(product.id, "color", event.target.value)}
      >
        <option value="">Select a color</option>
        {product.colors.map((color) => (
          <option key={color} value={color}>
            {color}
          </option>
        ))}
      </select>

      {personalizationEnabled ? (
        <>
          <label className="landstar-field-label" htmlFor={`personalization-${product.id}`}>
            Personalization
          </label>
          <input
            id={`personalization-${product.id}`}
            type="text"
            value={normalizedSelection.personalization}
            placeholder="Optional name or initials"
            onChange={(event) =>
              onSelectionChange(product.id, "personalization", event.target.value)
            }
          />
        </>
      ) : null}

      <button
        type="button"
        className={buttonClassName}
        disabled={lockedSelected || !normalizedSelection.size || !normalizedSelection.color}
        onClick={() => onSelect(product, normalizedSelection)}
      >
        {buttonLabel}
      </button>
    </article>
  );
}

export default ProductCard;
